export const initGallery = (root?: HTMLElement) => {
  // Stub de controlador de galería: no hace nada por ahora
  console.log('[gallery] init', root);
};
